import { AxiosResponse } from "axios";
import { CustomUseMutationOptions } from "@/types/common";
import { getAccessTokenApi } from "@/services/auth";
import { useMutation } from "@tanstack/react-query";

interface RequestAccessTokenParams {
  wallet_address: string;
  message: string;
  signature: string;
  service_name?: string;
}

interface RequestAccessTokenResponse {
  token: string;
}

export const useRequestAccessToken = (
  options?: CustomUseMutationOptions<
    AxiosResponse<RequestAccessTokenResponse>,
    unknown,
    RequestAccessTokenParams
  >
) => {
  const requestAccessToken = async (params: RequestAccessTokenParams) => {
    return await getAccessTokenApi(params);
  };

  return useMutation({
    mutationFn: requestAccessToken,
    ...options,
  });
};
